import ServicesView from './services_view';

export default ServicesView;
